import React, { useState, useEffect } from "react";
import './Navbar.css'
import home_nav from '../../assets/nav/home_nav.png'
import about_us_nav from '../../assets/nav/abous_us_nav.png'
import members_nav from '../../assets/nav/members_nav.png'
import portfolio_nav from '../../assets/nav/portfolio_nav.png'
import services_nav from '../../assets/nav/services_nav.png'
import contact_nav from '../../assets/nav/contact_nav.png'

const Navbar = ({ contentRef }) => {
  const pages = {
    home: "homePage",
    about: "about_page",
    members: "ourteamPage",
    portfolio: "hiveport_page",
    services: "services_page",
    contact: "contact_page",
  };
  
  const [timeoutState, setTimeoutState] = useState(false);
  const [selectedSection, setSelectedSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        // Get the current scroll position of the content
        const scrollPosition = contentRef.current.scrollTop;

        // Loop through each page and check if the scroll position matches
        let currentSection = "home"; // Default section
        Object.keys(pages).forEach((key) => {
          const element = document.querySelector(`.${pages[key]}`);
          if (element) {
            const offset = element.offsetTop;
            const height = element.clientHeight;
            if (scrollPosition >= offset - 100 && scrollPosition < offset + height - 100) { // Adjust 100 as a buffer
              currentSection = key;
            }
          }
        });

        // Update the selected section if it's different
        if (currentSection !== selectedSection) {
          setSelectedSection(currentSection);
        }
      }
    };

    // Add the scroll event listener
    if (contentRef.current) {
      contentRef.current.addEventListener("scroll", handleScroll);
    }

    // Clean up the event listener
    return () => {
      if (contentRef.current) {
        contentRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [selectedSection, contentRef]); // Re-run the effect when selectedSection or contentRef changes

  const scrollTo = (elementId) => {
    const element = document.querySelector(`.${elementId}`);
    if (element && contentRef.current) {
      const offset = element.offsetTop;
      contentRef.current.scrollTo({
        top: offset,
        behavior: "smooth",
      });
    }
  };

  const toggleNewSection = (index) => {
    setSelectedSection(index);
  };

  const triggerNavMenu = (tip) => {
    if (!timeoutState) {
      setTimeoutState(true);
      if (tip === false) {
        document.querySelector(".nav_menu").classList.remove("nav_menu_triggered");
        document.querySelector(".trigger_menu").style.borderRadius = "5px";
      } else {
        document.querySelector(".trigger_menu").style.borderRadius = "5px 0px 0px 5px";
        document.querySelector(".nav_menu").classList.add("nav_menu_triggered");
      }

      setTimeout(() => {
        setTimeoutState(false);
      }, 900);
    }
  };

  const handleNavClick = (id) => {
    if (!document.querySelector(`#${id}_section_navigation`).classList.contains("selected_navitem")) {
      toggleNewSection(id);
      scrollTo(pages[id]);
    }
  };

  return (
    <div className="nav_bar_cont">
      <div
        className="trigger_menu"
        onClick={() =>
          triggerNavMenu(
            !document.querySelector(".nav_menu").classList.contains("nav_menu_triggered")
          )
        }
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

    
      <div className="nav_menu">
        {Object.keys(pages).map((key) => (
          <div
            key={key}
            id={`${key}_section_navigation`}
            className={`nav_box ${selectedSection === key ? "selected_navitem" : ""}`}
            onClick={() => handleNavClick(key)}
          >
            <img src={
              key === "home" ? home_nav :
              key === "about" ? about_us_nav :
              key === "members" ? members_nav :
              key === "portfolio" ? portfolio_nav :
              key === "services" ? services_nav :
              contact_nav
            } alt={`Hive ${key.charAt(0).toUpperCase() + key.slice(1)}`} />
            <div className="text_content">Hive {key.charAt(0).toUpperCase() + key.slice(1)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Navbar;
